import { api } from 'shared';
import { z } from 'zod';

export const FaqsResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            question: z.string(),
            answer: z.any().optional(),
        }),
    ).optional().nullable(),
});
export const fetchFaqs = async () => (
    api.get<z.infer<typeof FaqsResponseSchema>>(
        '/faqs',
        {},
        FaqsResponseSchema,
    )
);
